import styled from "styled-components";

export const Wrapper = styled("div")`
  padding: 10px 9px;
  border-radius: 10px;
  
  background-color: #fff;
`;
